export const SENTRY_LOG_DETAIL_MAX_LENGTH = 500;

/** Limit detail appended to Sentry log messages for searchability without huge lines. */
export function truncateForSentryLogDetail(
	text: string,
	maxLength = SENTRY_LOG_DETAIL_MAX_LENGTH
): string {
	if (text.length <= maxLength) {
		return text;
	}
	return `${text.slice(0, maxLength)}…`;
}

/** Append capped serialised detail after the log alias. */
export function appendSentryLogDetail(
	alias: string,
	detail: string,
	maxLength = SENTRY_LOG_DETAIL_MAX_LENGTH
): string {
	if (!detail) {
		return alias;
	}
	return `${alias}: ${truncateForSentryLogDetail(detail, maxLength)}`;
}

/** Safely converts any value to a string, handling circular references and non-serializable types. */
export function safeStringify(value: unknown): string {
	try {
		if (value == null) return 'Unknown error';
		if (typeof value === 'string') return value;
		if (value instanceof Error) return value.message;
		return JSON.stringify(value);
	} catch {
		return '[Unserializable value]';
	}
}
